<template>
  <base-dialog v-model="isShowDialog" title="라이브 리모컨 사용법" :width="800">
    <video :src="src" alt="example-obs-link" style="width: 100%; height: auto; border-radius: 8px" autoplay loop />
    <template #actions>
      <v-btn color="primary" text @click="prevent1Week">이 메세지를 1주일간 보지 않기</v-btn>
      <v-btn color="primary" @click="isShowDialog = false">닫기</v-btn>
    </template>
  </base-dialog>
</template>

<script>
// import src from "@/assets/example-obs-link.gif";
import src from "@/assets/guide_A55fLjS0.mp4";
import moment from "moment";
export default {
  props: {},
  created() {
    this.src = src;

    this.isShowDialog = (() => {
      const afterDate = localStorage.getItem("isShowObsExampleDialog");
      if (!afterDate) return true;

      const after = moment(afterDate);
      const res = moment().isAfter(after);
      return res;
    })();
  },
  data() {
    return {
      src: null,
      isShowDialog: false,
    };
  },
  mounted() {},
  methods: {
    prevent1Week() {
      const now = moment().add(7, "days").format("YYYY-MM-DD");
      localStorage.setItem("isShowObsExampleDialog", `${now} 23:59:59`);
      this.isShowDialog = false;
    },
    onClose() {
      this.isShowDialog = false;
    },
  },
};
</script>

<style></style>
